import z from "zod";

const contextErrorTypeValues = [
  "DISABLED_USER_CONTEXT_CREATION",
  "USER_NOT_FOUND",
  "USER_NOT_FOUND_IN_CONTEXT",
  "MISSING_IMPERSONATION_PERMISSION",
  "MISSING_HISTORY_ORIGIN",
  "TRANSACTION_EXPIRED",
] as const;
const contextErrorTypeSchema = z.enum(contextErrorTypeValues);
export const ContextErrorType = contextErrorTypeSchema.enum;
type ContextErrorType = z.infer<typeof contextErrorTypeSchema>;

export type ContextErrors =
  | {
      errorType: typeof ContextErrorType.DISABLED_USER_CONTEXT_CREATION;
      data: {
        personId: string;
      };
    }
  | {
      errorType: typeof ContextErrorType.USER_NOT_FOUND;
      data: {
        userId?: string;
      };
    }
  | {
      errorType: typeof ContextErrorType.USER_NOT_FOUND_IN_CONTEXT;
      data: undefined;
    }
  | {
      errorType: typeof ContextErrorType.MISSING_IMPERSONATION_PERMISSION;
      data: {
        userId: string;
      };
    }
  | {
      errorType: typeof ContextErrorType.MISSING_HISTORY_ORIGIN;
      data: undefined;
    }
  | {
      errorType: typeof ContextErrorType.TRANSACTION_EXPIRED;
      data: undefined;
    };

export const contextErrorDetails: Record<ContextErrorType, { sentryDescription: string }> = {
  DISABLED_USER_CONTEXT_CREATION: {
    sentryDescription: "Attempted to create user context for a disabled person",
  },
  USER_NOT_FOUND: {
    sentryDescription: "User Not Found",
  },
  USER_NOT_FOUND_IN_CONTEXT: {
    sentryDescription: "User Not Found In Context",
  },
  MISSING_IMPERSONATION_PERMISSION: {
    sentryDescription: "Missing Impersonation Permission",
  },
  MISSING_HISTORY_ORIGIN: {
    sentryDescription:
      "createRemiAutomationsContext was called without a valid origin; pass a SettableHistoryOrigin, e.g. HistoryOrigin.SCRIPT",
  },
  TRANSACTION_EXPIRED: {
    sentryDescription: "Interactive transaction ran past its timeout and the next query hit a Prisma engine panic",
  },
};
